export default {
    shipments: ( state ) => {
        return state.shipments;
    }
}